module.exports = __webpack_public_path__ + "static/img/kn.59d27824.svg";